import React from 'react';
import './RoundSelectionModal.css';

const RoundSelectionModal = ({ isOpen, onSelect, onClose, courseName }) => {
  if (!isOpen) return null;

  const rounds = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content round-selection-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Select Round</h2>
          <p>Which round is <strong>{courseName}</strong>?</p>
        </div>
        <div className="round-grid">
          {rounds.map((round) => (
            <button 
              key={round} 
              className="round-key-button"
              onClick={() => onSelect(round)}
            >
              {round}
            </button>
          ))}
        </div>
        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default RoundSelectionModal;
